module.exports = __webpack_public_path__ + "static/media/02-Process.f6e12cf3.gif";